module.exports = __webpack_public_path__ + "static/media/MongoDB.b10b140c.png";